import {Component, ChangeDetectionStrategy, Input} from '@angular/core';

import {Modal, ModalAction, ModalResult} from './modal.component';
import {SystemPaths} from './system-paths';

declare var Pace;
declare var window;


@Component({
    selector: 'common-modals',
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
	<modal style="position: fixed; z-index: 1200;"
        [show-dialog]="false"
        (loaded)="modals.overlay.loadedHandler($event)"
        (closed)="modals.overlay.closedHandler($event)">
	</modal>

	<modal class="text-left" style="position: fixed; z-index: 1200;"
	    [title]="modals.genericOk.title"
        [positive-label]="'OK'"
        (loaded)="modals.genericOk.loadedHandler($event)"
        (closed)="modals.genericOk.closedHandler($event)">

    	<div>
    		{{modals.genericOk.message}}
    	</div>
	</modal>

	<modal class="text-left" style="position: fixed; z-index: 1200;"
		[title]="'Login Required'"
		[cancel-label]="'Cancel'"
		[positive-label]="'Login'"
		[positive-extra-label]="'Register'"
		(loaded)="modals.unauthenticated.loadedHandler($event)"
    (closed)="modals.unauthenticated.closedHandler($event)">

    	<div>
    		You must be logged in to make changes
    		to any of the content at <span style="color: #dd9900; font-weight: bold;">MySportsFeeds</span>.<br/>
    		<br/>
    	    Members can earn points and compete for bragging rights, by:<br/>
    		<ul>
                <li>Suggesting Player changes or additions</li>
                <li>Suggesting changes to Game Schedule</li>
                <li>Suggesting pre-game lineups</li>
                <li>Making changes to play-by-plays for Games <b>in REAL-TIME</b></li>
                <li>Suggesting corrections for <b>COMPLETED</b> Games</li>
                <li>Just chatting in the comments section for Games</li>
    		</ul>
    		See our <a href="{{memberBenefitsHref}}">member benefits</a> page for more details.<br/>
    		<br/>
			With a monthly subscription, members can also download any of our flexible <a href="{{dataFeedsListHref}}">data feeds</a> in JSON/XML/CSV.
    	</div>
	</modal>
    `
})
export class CommonModalsComponent {
	@Input() modals;

	public memberBenefitsHref;
	public dataFeedsListHref;

	constructor(protected systemPaths: SystemPaths) {
		this.memberBenefitsHref = this.systemPaths.memberBenefits();
		this.dataFeedsListHref = this.systemPaths.dataFeeds();
	}

}
